import { render, staticRenderFns } from "./CreateMulti.vue?vue&type=template&id=0bf30eb6&v-on-clickaway=cancel&"
import script from "./CreateMulti.vue?vue&type=script&lang=ts&"
export * from "./CreateMulti.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports